<template>
        <div class="templete">
            <div class="search_box clearfix StockSearch">
                 <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.search.customer_id" placeholder="客户" filterable>
                    <el-option v-for="list in customerList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.search.salesman_id" placeholder="销售人">
                    <el-option v-for="list in saleList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.search.order_sn" placeholder="单据编号"></el-input>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="tableBox selectStockTable">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" :selecttype="1" @rowClick="rowClick"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <div class="btnList clearfix">
                <div class="btnBox">
                    <el-button  class="funcPublicBtn" @click="cancel">取消</el-button>
                    <el-button  class="funcPublicBtn" @click="selectData">选中</el-button>
                    <el-button  class="funcPublicBtn funcPublicBtnChecked" @click="selectAndOut">选中并退出</el-button>
                </div>
            </div>
        </div>
</template>
<script>
    import tabletem from './table.vue'
    import pagination from './pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                params:{
                    search:{
                        start_time:"",
                        end_time:"",
                        customer_id:"",
                        salesman_id:"",
                        order_sn:""
                    },
                    per_page:50,
                    page:1
                },
                start_time:"",
                end_time:"",
                last_page:1,
                total:0,
                selectRow:[],
                customerList:[],
                saleList:[],
                list:[],
                tableCol:[	
                    {colName:"客户",colKey:"customer_name",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售日期",colKey:"sales_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售单号",colKey:"order_sn",colWidth:190,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"件数",colKey:"count",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"方数",colKey:"sales_cube",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售人",colKey:"salesman_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"审核人",colKey:"auditor_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:160,isSetWidth:true,isCanClick:false,isShow:true}
                ]
            }
        },
        created(){
            this.$getCustomerList().then(res=>{
                this.customerList=res.data.data;
            })
            this.$getSalemanList().then(res=>{
                this.saleList=res.data.data;
            })
            this.getList()
        },
        methods:{
            cancel(){
                this.$emit("cancel")
            },
            selectData(){
                this.$emit("selectData",this.selectRow)
            },
            selectAndOut(){
                this.$emit("selectAndOut",this.selectRow)
            },
            reset(){
                this.start_time="";
                this.end_time="";
                this.params={search:{start_time:"",end_time:"",customer_id:"",salesman_id:"",order_sn:""},per_page:50,page:1}
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.start_time=this.formatTimeZero(this.start_time)
                this.params.search.end_time=this.formatTimeZero(this.end_time)
                this.tableLoading = true;
                this.postFunc("/erp/return.orders",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.list;
                    this.list.forEach((item,index)=>{
                        if(item.sales_time!=0){
                            this.list[index].sales_time = this.formatTime(item.sales_time+"000")
                        }
                        // this.list[index].thickness = this.keepLimit(item.thickness)
                        // this.list[index].length = this.keepLimit(item.length)
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(){},
            getRow(row){
                this.selectRow=row;
                
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
<style scoped>
    .pageAssembly .pageSize{margin-top:3px;}
    .totalBox{float: left;}
    .totalBox .total{float: left;font-size: 12px;line-height: 33px;margin-right:15px;}
    .btnBox{float: right;}
</style>